import { render, staticRenderFns } from "./TwoFactorCard.vue?vue&type=template&id=237d1d5c&scoped=true"
import script from "./TwoFactorCard.vue?vue&type=script&lang=js"
export * from "./TwoFactorCard.vue?vue&type=script&lang=js"
import style0 from "./TwoFactorCard.vue?vue&type=style&index=0&id=237d1d5c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "237d1d5c",
  null
  
)

export default component.exports